import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CheckForDelete } from 'src/app/Modules/informate/models';

@Component({
    selector: 'app-warning-dialog',
    templateUrl: './warning-dialog.component.html',
    styleUrls: ['./warning-dialog.component.scss'],
})
export class WarningDialogComponent implements OnInit {
    @Input() message: string;
    @Input() childData: CheckForDelete[];
    constructor(private ngbActiveModal: NgbActiveModal) {}

    ngOnInit(): void {}

    closeModal() {
        this.ngbActiveModal.close();
    }
}
